import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './auth/signin/signin.component';
import { SignupComponent } from './auth/signup/signup.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { AuthGuard } from './guards/auth.guard';
import { DashGuard, DashMatchGuard } from './guards/dashboard.guard';
import { AccountActivationComponent } from './auth/account-activation/account-activation.component';
import { ResendEmailComponent } from './auth/resend-email/resend-email.component';

const routes: Routes = [
  { path: "auth/signin", component: SigninComponent, canActivate: [AuthGuard] },
  { path: "auth/signup", component: SignupComponent, canActivate: [AuthGuard] },
  { path: "auth/forgot-password", component: ForgotPasswordComponent, canActivate: [AuthGuard] },
  // Pas de AuthGuard ici : un utilisateur qui clique sur le lien recu par email
  // doit pouvoir reinitialiser son mot de passe meme s'il a deja une session
  // active dans ce navigateur (sinon il est redirige vers /dashboard sans jamais
  // voir le formulaire).
  { path: "auth/reset-password", component: ResetPasswordComponent },
  { path: "auth/account-activation", component: AccountActivationComponent, canActivate: [AuthGuard] },
  { path: "auth/resend-verification", component: ResendEmailComponent, canActivate: [AuthGuard] },
  {
    path: '',
    loadChildren: () => import('./site/site.module').then(m => m.SiteModule)
  },
  {
    path: 'dashboard',
    canActivate: [DashGuard],
    canMatch: [DashMatchGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    // scrollOffset: [0, 64]
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
